import PrivacyModal from "./privacy-modal";

export default PrivacyModal;
